/* Svensk katalog for locale-invoice-detail-no.js (del 1 av 2).
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('sv', {
  'inv.detail.completion': 'Genomförande',
  'inv.detail.completed': 'Genomförd',
  'inv.detail.notCompleted': 'Inte genomförd',
  'inv.detail.paymentStatus': 'Betalningsstatus',
  'inv.detail.paid': 'Betald',
  'inv.detail.remaining': 'Återstår',
  'inv.detail.registeredPayments': 'Registrerade betalningar',
  'inv.detail.registerPayment': 'Registrera betalning',
  'inv.detail.settlementStatus': 'Reglering',
  'inv.detail.creditOffset': 'Kvittad',
  'inv.detail.creditRefunded': 'Återbetald',
  'inv.detail.creditOpen': 'Inte återbetald',
  'inv.detail.offsetAgainst': 'Kvittad mot {document}',
  'inv.detail.offsetAgainstInvoice': 'Kvittad mot fakturan',
  'inv.detail.refunded': 'Återbetald',
  'inv.detail.toCredit': 'Tillgodo',
  'inv.detail.registeredRefunds': 'Registrerade återbetalningar',
  'inv.detail.registerRefund': 'Registrera återbetalning',
  'inv.detail.amountTitle': 'Belopp',
  'inv.detail.amountHelp': 'Netto, moms och totalbelopp är beräknade utifrån de sparade fakturaraderna.',
  'inv.detail.net': 'Netto',
  'inv.detail.totalAmount': 'Totalt belopp',
  'inv.detail.history': 'Historik',
  'inv.detail.action': 'Åtgärd',
  'inv.detail.loadingDoc': 'Läser in dokument...',
  'inv.detail.openedFromLink': 'Dokument öppnat från länk',
  'inv.act.open': 'Öppna',
  'inv.act.openHelp': 'Öppna utkastet i Ny försäljning för att redigera och skicka det.',
  'inv.act.send': 'Skicka',
  'inv.act.sendAgain': 'Skicka igen',
  'inv.act.sendCreditNote': 'Skicka kreditfaktura',
  'inv.act.sendHelp': 'Skicka dokumentet till kunden via e-post via backend.',
  'inv.act.markDelivered': 'Markera som levererad',
  'inv.act.markDeliveredHelp': 'Använd när dokumentet har levererats till kunden utanför Plumme.',
  'inv.act.view.invoice': 'Visa faktura',
  'inv.act.view.quote': 'Visa offert',
  'inv.act.view.orderConfirmation': 'Visa orderbekräftelse',
  'inv.act.view.creditNote': 'Visa kreditfaktura',
  'inv.act.viewHelp': 'Förhandsgranska dokumentet så som kunden ser det.',
  'inv.act.copyLink': 'Kopiera länk',
  'inv.act.copyLinkHelp': 'Kopiera en delbar länk till dokumentet.',
  'inv.act.download': 'Ladda ner',
  'inv.act.downloadHelp': 'Ladda ner dokumentet som PDF.',
  'inv.act.packingSlip': 'Skapa följesedel',
  'inv.act.packingSlipHelp': 'Skapa och ladda ner en följesedel för varorna på den här fakturan.',
  'inv.act.copy': 'Skapa kopia',
  'inv.toast.copyOpened': 'Kopian är öppnad — spara den som utkast eller skapa den',
  'inv.act.share': 'Dela',
  'inv.act.shareHelp': 'Kopiera delningslänk, ladda ner PDF eller skapa följesedel.',
  'inv.share.title': 'Dela dokumentet',
  'inv.act.convertOffer': 'Skapa',
  'inv.act.convertOfferHelp': 'Skapar en faktura eller orderbekräftelse som utkast, med kunden och raderna från offerten.',
  'inv.convert.title': 'Skapa från offerten',
  'inv.convert.invoice': 'Faktura',
  'inv.convert.invoiceHelp': 'Vanlig betalningsfrist. Bokförs när du skapar den.',
  'inv.convert.order': 'Orderbekräftelse',
  'inv.convert.orderHelp': 'Bekräftar avtalet utan att fakturera. Kan faktureras senare.',
  'inv.act.markAccepted': 'Markera som accepterad',
  'inv.act.markAcceptedHelp': 'Använd denna när kunden har godkänt offerten muntligt, på ett möte eller via e-post. Godkännande som kunden själv gör i offertlänken registreras automatiskt.',
  'inv.act.undoAccepted': 'Ta bort godkännande',
  'inv.act.undoAcceptedHelp': 'Ångrar ett godkännande som registrerades här i appen. Godkännande som kunden själv har klickat på kan inte tas bort.',
  'inv.act.copyHelp': 'Skapa en ny faktura med samma innehåll som den här.',
  'inv.act.credit': 'Kreditera',
  'inv.act.creditHelp': 'Skapa en kreditfaktura som kvittar den här fakturan.',
  'inv.act.delete': 'Ta bort',
  'inv.act.deleteHelp': 'Ta bort det här utkastet. Kan inte ångras.',
  'inv.err.actionFailed': 'Åtgärden kunde inte slutföras.',
  'inv.err.openDoc': 'Kunde inte öppna dokumentet.',
  'inv.err.previewPacking': 'Kunde inte förhandsgranska följesedeln.',
  'inv.err.settleNotConnected': 'Reglering utan betalning är inte ansluten till backend.',
  'inv.err.settleFailed': 'Kunde inte reglera utan betalning.',
  'inv.err.needEmail': 'Ange mottagarens e-post först.',
  'inv.err.emailCharset': 'E-postadresser får inte innehålla æ, ø, å eller andra specialtecken.',
  'inv.err.invalidEmail': 'Det här ser inte ut som en giltig e-postadress.',
  'inv.err.acceptNotConnected': 'Godkännande är inte anslutet till backend.',
  'inv.err.acceptFailed': 'Kunde inte uppdatera godkännandet.',
  'inv.err.convertNotConnected': 'Konvertering är inte ansluten till backend.',
  'inv.err.convertOpenFailed': 'Utkastet skapades men kunde inte öppnas.',
  'inv.err.convertFailed': 'Kunde inte skapa dokumentet från offerten.',
  'inv.err.copyOpenFailed': 'Kopian skapades men kunde inte öppnas.',
  'inv.err.deleteNotConnected': 'Borttagning är inte ansluten till backend.',
  'inv.err.deleteFailed': 'Kunde inte ta bort utkastet.',
  'inv.toast.onlyDrafts': 'Bara utkast kan tas bort här',
  'inv.toast.offerAccepted': 'Offerten är markerad som accepterad',
  'inv.toast.offerAcceptanceRemoved': 'Godkännandet har tagits bort',
  'inv.toast.invoiceDraftFromOffer': 'Fakturan är öppnad — spara den som utkast eller skapa den',
  'inv.toast.orderDraftFromOffer': 'Orderbekräftelsen är öppnad — spara den som utkast eller skapa den',
  'inv.toast.draftDeleted': 'Utkast borttaget',
  'inv.pay.settleWithout': 'Reglerad utan betalning',
  'inv.pay.saveChange': 'Spara ändring',
  'inv.pay.paidDate': 'Betalningsdatum',
  'inv.pay.datePh': 'dd.mm.åååå',
  'inv.pay.registerPaymentTitle': 'Registrera betalning',
  'inv.pay.editPaymentTitle': 'Redigera betalning',
  'inv.pay.registerRefundTitle': 'Registrera återbetalning',
  'inv.pay.editRefundTitle': 'Redigera återbetalning',
  'inv.pay.paidFrom': 'Betald från',
  'inv.pay.refundDate': 'Återbetalningsdatum',
  'inv.pay.refundAmount': 'Återbetalt belopp',
  'inv.pay.remainingNote': 'Återstående på fakturan: {amount}. Du kan registrera en delbetalning.',
  'inv.pay.refundNote': 'Kunden har {amount} tillgodo på kreditfakturan. Du kan registrera en delvis återbetalning.',
  'inv.pay.refundHelp': 'Kreditfakturan återför försäljningen oavsett. Registrera återbetalning bara när kunden faktiskt får tillbaka pengar.',
  'inv.pay.fee': 'Bank- och kortavgift',
  'inv.pay.feeAccount': 'Avgiftskonto',
  'inv.pay.bankAmountIn': 'Faktiskt belopp in på banken: {amount}',
  'inv.pay.bankAmountOut': 'Faktiskt belopp ut från banken: {amount}',
  'inv.detail.offsetCustomerCredit': 'Kvitta kundtillgodo',
  'inv.detail.customerCreditOffset': 'Kvittat kundtillgodo',
  'inv.detail.customerCreditAllocated': 'Kvittat mot annan faktura',
  'inv.detail.relatedRefund': 'Återbetald via tillhörande kreditfaktura',
  'inv.toast.customerCreditOffset': 'Kundtillgodo har kvittats mot fakturan',
  'inv.err.noCustomerCredit': 'Ingen tillgänglig kreditfaktura för kunden hittades.',
  'inv.err.customerCreditOffsetFailed': 'Kunde inte kvitta kundtillgodo.',
  'cust.ledger.creditOffset': 'Kvittat kundtillgodo',
  'inv.toast.paymentRegistered': 'Inbetalning registrerad',
  'inv.toast.paymentUpdated': 'Betalning uppdaterad',
  'inv.toast.refundRegistered': 'Återbetalning registrerad',
  'inv.toast.refundUpdated': 'Återbetalning uppdaterad',
  'inv.err.paymentFailed': 'Kunde inte registrera inbetalningen.',
  'inv.err.paymentUpdateFailed': 'Kunde inte uppdatera betalningen.',
  'inv.err.refundFailed': 'Kunde inte registrera återbetalningen.',
  'inv.err.refundUpdateFailed': 'Kunde inte uppdatera återbetalningen.',
  'inv.del.confirm': 'Ja, ta bort utkast',
  'inv.del.body': 'Är du säker på att du vill ta bort det här utkastet för {customer}? Detta kan inte ångras.',
  'inv.send.body': '{document} på {amount} skickas till {customer} som PDF via e-post.',
  'inv.send.resendNote': ' Detta är ett nytt utskick av ett redan skickat dokument.',
  'inv.credit.continue': 'Till kreditering',
  'inv.credit.intro': 'En kreditfaktura kvittar fakturan för {customer}. Välj om du vill kreditera hela fakturan eller bara delar av den.',
  'inv.credit.full': 'Full kreditering',
  'inv.credit.partial': 'Delkreditering',
  'inv.credit.line': 'Rad',
  'inv.credit.count': 'Antal',
  'inv.credit.credited': 'Krediteras',
  'inv.credit.total': 'Kreditfakturans belopp',
  'inv.credit.breakdown': 'Netto {net} · Moms {vat}',
  'inv.credit.partialSuffix': ' · delkreditering',
  'inv.delivery.rowFailed': 'Kom inte fram',
  'inv.delivery.bannerTitle': '{n} dokument kom inte fram till mottagaren',
  'inv.delivery.bannerBody': 'E-postmeddelandet avvisades eller kom i retur: {documents}. Öppna dokumentet, rätta e-postadressen på kunden och skicka igen.',
  'inv.credit.rest': 'Kreditera resten',
  'inv.credit.alreadyCredited': 'Redan krediterat: {amount}. Du kan bara kreditera det som återstår.',
  'inv.credit.closedLines': '{n} rader är färdigkrediterade och visas inte.',
  'inv.credit.lineAlready': 'krediterat {amount}',
  'inv.credit.hasPayments': 'Fakturan har registrerade betalningar. Kreditfakturan kvittar det öppna beloppet; en eventuell återbetalning registreras separat.',
  'inv.credit.date': 'Kreditfakturadatum',
  'inv.credit.dateHint': 'Datumet avgör i vilken redovisnings- och momsperiod krediteringen förs.',
  'inv.credit.dateBeforeInvoice': 'Kreditnotans datum f?r inte vara f?re fakturadatumet.',
  'inv.credit.invalidDate': 'Välj ett giltigt datum för kreditfakturan.',
  'inv.credit.paidConfirmTitle': 'Fakturan är betald',
  'inv.credit.paidConfirmBody': 'Vi ser att fakturan har registrerade inbetalningar på {amount}. Kreditfakturan återför försäljningen, men en eventuell återbetalning registreras separat. Vill du fortsätta?',
  'inv.credit.paidConfirmContinue': 'Ja, fortsätt krediteringen',
  'inv.bulk.creditDateHint': 'Samma datum används på alla kreditfakturor. Datumet avgör bokförings- och momsperioden.',
  'inv.bulk.creditDateBeforeInvoices': 'Datumet f?r inte vara f?re det senaste fakturadatumet i urvalet.',
  'inv.bulk.creditPaidConfirmBody': '{n} av de valda fakturorna har registrerade inbetalningar. Kreditfakturorna återför försäljningen, men eventuella återbetalningar registreras separat. Vill du fortsätta?',
  'inv.history.creditPartial': 'Delkrediterad {amount} · kreditfaktura {document}',
  'inv.history.creditFull': 'Krediterad {amount} · kreditfaktura {document}',
  'inv.history.creditDraft': 'Kreditfaktura {document} skapad som utkast · {amount}',
  'inv.history.creditNoNumber': 'utan nummer',
  'inv.toast.creditOpened': 'Kreditfakturan för {document} är öppnad — fyll i orsak och skapa den',
  'inv.toast.partialCreditOpened': 'Delkreditfakturan för {document} är öppnad — fyll i orsak och skapa den',
  'inv.bulk.selectAll': 'Välj alla som visas',
  'inv.bulk.selectRow': 'Välj dokument. Skift-klick väljer intervallet.',
  'inv.bulk.selectDocument': 'Välj dokument',
  'inv.bulk.selectDocuments': 'Välj dokument',
  'inv.bulk.selectedCount': '{n} valda',
  'inv.bulk.shownCount': '{n} visas i listan',
  'inv.bulk.reset': 'Återställ',
  'inv.bulk.deliver': 'Markera som levererad',
  'inv.bulk.resend': 'Skicka igen',
  'inv.bulk.reminder': 'Påminnelse',
  'inv.bulk.credit': 'Kreditera',
  'inv.bulk.issue': 'Skapa och skicka',
  'inv.bulk.delete': 'Ta bort',
  'inv.bulk.processing': 'Bearbetar ...',
  'inv.bulk.document': 'Dokument',
  'inv.bulk.amount': 'Belopp',
  'inv.bulk.more': '+ {n} till',
  'inv.bulk.noEmail': 'saknar e-post',
  'inv.bulk.newDueDate': 'ny förfallodag {date}',
  'inv.bulk.reminderType': 'Typ',
  'inv.bulk.reminderNotice': 'Betalningspåminnelse',
  'inv.bulk.reminderDunning': 'Påminnelse',
  'inv.bulk.reminderDueDays': 'Dagar till ny förfallodag',
  'inv.bulk.reminderFee': 'Påminnelseavgift',
  'inv.bulk.reminderFeeLocked': 'Avgift kan bara läggas på vid påminnelse.',
  'inv.bulk.delivery': 'Skickas som',
  'inv.bulk.deliveryPdf': 'PDF-bilaga',
  'inv.bulk.deliveryLink': 'Länk',
  'inv.bulk.comment': 'Kommentar till kunden',
  'inv.bulk.commentHint': 'Visas i e-postmeddelandet tillsammans med beloppsöversikten. Själva fakturan ändras inte.',
  'inv.bulk.commentPh': 'Till exempel: Vi ser att fakturan är obetald. Hör av dig om något är oklart.',
  'inv.comment.label': 'Kommentar till kunden',
  'inv.comment.hint': 'Valfri text som följer med det här utskicket.',
  'inv.comment.placeholder': 'Skriv en kommentar ...',
  'inv.comment.useSaved': 'Använd kommentar',
  'inv.comment.save': 'Spara kommentar',
  'inv.comment.update': 'Uppdatera kommentar',
  'inv.comment.saveTitle': 'Spara kommentar',
  'inv.comment.updateTitle': 'Uppdatera kommentar',
  'inv.comment.saveAsNew': 'Spara som ny',
  'inv.comment.savedTitle': 'Sparade kommentarer',
  'inv.comment.name': 'Kommentarens namn',
  'inv.comment.namePh': 'Till exempel: Vänlig påminnelse',
  'inv.comment.nameHint': 'Namnet är det du hittar kommentaren på i listan.',
  'inv.comment.needName': 'Ge kommentaren ett namn först',
  'inv.comment.empty': 'Du har inga sparade kommentarer än.',
  'inv.comment.use': 'Använd',
  'inv.comment.saved': 'Kommentaren har sparats',
  'inv.comment.updated': 'Kommentaren har uppdaterats',
  'inv.comment.deleted': 'Kommentaren har tagits bort',
  'inv.comment.saveFailed': 'Kunde inte spara kommentaren.',
  'inv.comment.deleteFailed': 'Kunde inte ta bort kommentaren.',
  'inv.comment.notConnected': 'Kommentarer är inte kopplade till backend.',
  'inv.bulk.mode': 'Vad ska hända',
  'inv.bulk.mode.draft': 'Spara som utkast',
  'inv.bulk.mode.send': 'Skapa och skicka',
  'inv.bulk.mode.create': 'Bara skapa',
  'inv.bulk.mode.hint.credit': 'Kreditfakturorna läggs i fliken Utkast. Inget bokförs eller skickas förrän du skapar dem.',
  'inv.bulk.mode.hint.creditSend': 'Kreditfakturorna bokförs och skickas till kunderna direkt. Detta kan inte ångras.',
  'inv.bulk.mode.hint.issueSend': 'Utkasten bokförs med dokumentnummer och skickas till kunderna via e-post.',
  'inv.bulk.mode.hint.issue': 'Utkasten bokförs med dokumentnummer, men inget e-postmeddelande skickas.',
  'inv.bulk.creditReasonOptional': 'Valfritt så länge kreditfakturan ligger som utkast. Orsaken måste finnas innan den kan bokföras.',
  'inv.bulk.creditReasonRequired': 'Obligatoriskt. Orsaken står på kreditfakturan och är underlaget för att försäljningen återfördes.',
  'inv.bulk.title.deliver': 'Markera valda dokument som levererade',
  'inv.bulk.title.send': 'Skicka valda dokument igen',
  'inv.bulk.title.reminder': 'Skicka påminnelse eller betalningspåminnelse',
  'inv.bulk.title.credit': 'Kreditera valda fakturor',
  'inv.bulk.title.issue': 'Skapa valda utkast',
  'inv.bulk.title.delete': 'Ta bort valda utkast',
  'inv.bulk.confirm.deliver': 'Markera som levererad',
  'inv.bulk.confirm.send': 'Skicka igen',
  'inv.bulk.confirm.reminder': 'Skicka uppföljning',
  'inv.bulk.confirm.credit': 'Skapa kreditfakturor',
  'inv.bulk.confirm.creditSend': 'Skapa och skicka kreditfakturor',
  'inv.bulk.confirm.issue': 'Skapa dokumenten',
  'inv.bulk.confirm.issueSend': 'Skapa och skicka',
  'inv.bulk.confirm.delete': 'Ja, ta bort utkasten',
  'inv.bulk.body.deliver': 'Dokument som markeras som levererade utanför Plumme: {n}. Inget e-postmeddelande skickas, och bokföring och betalning ändras inte.',
  'inv.bulk.body.send': '{n} dokument skickas till den e-postadress som finns på kunden.',
  'inv.bulk.body.reminder': '{n} förfallna eller obetalda fakturor följs upp. Originalfakturan bokförs inte på nytt.',
  'inv.bulk.body.credit': '{n} fakturor krediteras för det som återstår, en kreditfaktura per faktura. Redan krediterade rader tas inte med igen.',
  'inv.bulk.body.creditSend': '{n} fakturor krediteras för det som återstår. Kreditfakturorna skapas, bokförs och skickas till kunden direkt — du slipper gå via utkast.',
  'inv.bulk.body.issue': '{n} utkast skapas och bokförs, och får dokumentnummer.',
  'inv.bulk.body.issueSend': '{n} utkast skapas, bokförs och skickas till kunden via e-post.',
  'inv.bulk.body.delete': '{n} utkast tas bort. Utkast är inte bokförda, men borttagningen kan inte ångras.',
  'inv.bulk.skip.deliver': 'Valda rader som är utkast, redan levererade eller skickade, och hoppas över: {n}.',
  'inv.bulk.skip.send': '{n} valda dokument saknar e-post och hoppas över.',
  'inv.bulk.skip.reminder': '{n} valda rader kan inte påminnas här eller saknar e-post.',
  'inv.bulk.skip.credit': '{n} valda rader kan inte krediteras här.',
  'inv.bulk.skip.issue': '{n} valda utkast saknar kund eller rader och kan inte skapas härifrån.',
  'inv.bulk.skip.noEmail': '{n} av dokumenten saknar e-postadress. De skapas och bokförs, men skickas inte.',
  'inv.bulk.skip.delete': '{n} valda rader är inte utkast och tas inte bort.',
  'inv.bulk.toast.delivered': 'Dokument markerade som levererade: {n}',
  'inv.bulk.toast.sent': '{n} dokument skickade',
  'inv.bulk.toast.reminded': '{n} betalningspåminnelser skickade',
  'inv.bulk.toast.dunned': '{n} påminnelser skickade',
  'inv.bulk.toast.credited': '{n} kreditfakturor skapade som utkast',
  'inv.bulk.toast.creditedSent': '{n} kreditfakturor skapade och skickade',
  'inv.bulk.toast.issued': '{n} dokument skapade',
  'inv.bulk.toast.issuedSent': '{n} dokument skapade och skickade',
  'inv.bulk.toast.deleted': '{n} utkast borttagna',
  'inv.bulk.toast.notSentSuffix': ', {n} skapade utan e-post',
  'inv.bulk.toast.failedSuffix': ', {n} misslyckades',
  'inv.bulk.err.failed': 'Kunde inte slutföra massåtgärden.',
  'inv.bulk.err.deliverNotConnected': 'Markering som levererad är inte kopplad till backend.',
  'inv.bulk.err.sendNotConnected': 'Utskick är inte kopplat till backend.',
  'inv.bulk.err.creditNotConnected': 'Kreditering är inte kopplad till backend.',
  'inv.bulk.err.issueNotConnected': 'Skapande av utkast är inte kopplat till backend.',
  'inv.packing.preview': 'Förhandsgranska',
  'inv.packing.download': 'Ladda ner följesedel',
  'inv.packing.invoiceDate': 'Fakturadatum',
  'inv.pay.account.1920': 'Företagskonto - 1920',
  'inv.pay.account.2063': 'Privat - 2063',
  'inv.pay.account.1900': 'Kontanter - 1900',
  'inv.report.customer': 'Kund',
  'inv.report.product': 'Produkt',
  'inv.report.salesCount': 'Antal försäljningar',
  'inv.report.count': 'Antal',
  'inv.report.exVat': 'Exkl. moms',
  'inv.report.share': 'Andel av totalt',
  'inv.report.noSales': 'Ingen försäljning under perioden.',
  'inv.report.noProducts': 'Inga produkter sålda under perioden.',
  'inv.report.openCustomer': 'Öppna {name} i Kunder',
  'inv.report.totalCustomers': '({n} kunder)',
  'inv.report.totalCustomer': '({n} kund)',
  'inv.report.totalProducts': '({n} produkter)',
  'inv.report.totalProduct': '({n} produkt)',
  'inv.report.total': 'Totalt',
  'inv.report.tile.sales': 'Försäljning',
  'inv.report.tile.activeCustomers': 'Aktiva kunder',
  'inv.report.tile.newCustomers': 'Nya kunder',
  'inv.report.tile.totalCustomers': 'Kunder totalt',
  'inv.report.tile.customerRevenue': 'Kundintäkter',
  'inv.report.tile.totalRevenue': 'Totala intäkter',
  'inv.report.tile.soldProducts': 'Sålda produkter',
  'inv.report.tile.productTypes': 'Produkttyper',
  'inv.report.tile.productRevenue': 'Produktintäkter',
  'inv.report.unknownCustomer': 'Okänd kund',
  'inv.report.unspecifiedSale': 'Ospecificerad försäljning',
  'inv.report.customerSummaryOne': '{sales} försäljningar registrerades till {customers} kund under perioden. Försäljning till kunder uppgick till {amount}.',
  'inv.report.customerSummaryMany': '{sales} försäljningar registrerades till {customers} kunder under perioden. Försäljning till kunder uppgick till {amount}.',
  'inv.report.productSummaryOne': '{count} produkter/rader av {types} produkttyp såldes under perioden, för totalt {amount}.',
  'inv.report.productSummaryMany': '{count} produkter/rader av {types} produkttyper såldes under perioden, för totalt {amount}.',
  'inv.fallback.noCustomer': 'Utan kund',
  'inv.fallback.line': 'Rad {n}',
  'inv.credit.fallbackDescription': 'Försäljning enl. {document}',
  'inv.credit.dialogTitle': 'Kreditera faktura {number}',
  'inv.detail.validUntil': 'Giltig till',
  'inv.detail.dueDate': 'Förfaller',
  'inv.detail.partiallyPaid': 'Delvis betald',
  'inv.detail.unpaid': 'Inte betald',
  'inv.detail.acceptedManual': 'Accepterad {date} · registrerad i appen',
  'inv.detail.acceptedCustomer': 'Accepterad {date} · av kunden',
  'inv.detail.orderSentAt': 'Orderbekräftelse skickad {date}',
  'inv.detail.paymentFeeBank': 'Avgift {fee} · Bank {bank}',
  'inv.detail.deliveryFailureHelp': 'Dokumentet är sparat, men mottagaren har inte fått det. Rätta adressen på kunden och skicka igen.',
  'inv.detail.timelineHelp': 'Tidslinje byggd från sparad dokumentstatus och betalningar.',
  'inv.history.offerAcceptedManual': 'Offert markerad som accepterad (registrerad i appen)',
  'inv.history.offerAcceptedCustomer': 'Offert accepterad av kunden',
  'inv.history.orderSent': 'Orderbekräftelse skickad',
  'inv.history.documentSentTo': '{document} skickad till {recipient}',
  'inv.history.deliveredExternally': 'Levererad utanför Plumme',
  'inv.history.documentCreated': 'Dokument skapat',
  'inv.packing.intro': 'Ange datum för utskick. Dagens datum är förvalt.',
  'inv.packing.shippingDate': 'Utskicksdatum',
  'inv.packing.contents': 'Följesedeln visar beskrivningar och antal från fakturaraderna. Priser, moms och betalningsinformation visas inte.',
  'inv.packing.title': 'Följesedel {number}',
  'inv.err.pdfPreviewNotConnected': 'PDF-visning är inte kopplad till backend.',
  'inv.err.packingNotConnected': 'Följesedel är inte kopplad till backend.',
  'inv.err.packingDownloadFailed': 'Det gick inte att ladda ner följesedeln.',
  'inv.err.paymentNotConnected': 'Inbetalning är inte kopplad till backend.',
  'inv.err.paymentEditNotConnected': 'Redigering av betalningar är inte kopplad till backend.',
  'inv.err.sendNotConnected': 'Utskick är inte kopplat till backend.',
  'inv.err.sendFailed': 'Det gick inte att skicka dokumentet.',
  'inv.err.deliverNotConnected': 'Markering som levererad är inte kopplad till backend.',
  'inv.err.deliverFailed': 'Det gick inte att markera dokumentet som levererat.',
  'inv.err.linkNotConnected': 'Fakturalänk är inte kopplad till backend.',
  'inv.err.linkFailed': 'Det gick inte att hämta fakturalänken.',
  'inv.err.downloadNotConnected': 'PDF-nedladdning är inte kopplad till backend.',
  'inv.err.downloadFailed': 'Det gick inte att ladda ner dokumentet.',
  'inv.err.copyNotConnected': 'Kopiering är inte kopplad till backend.',
  'inv.err.copyFailed': 'Det gick inte att skapa en kopia av dokumentet.',
  'inv.err.archiveNotConnected': 'Arkivering är inte kopplad till backend.',
  'inv.err.archiveFailed': 'Det gick inte att uppdatera arkivstatus.',
  'inv.err.creditNotConnected': 'Kreditering är inte kopplad till backend.',
  'inv.err.creditFailed': 'Det gick inte att skapa kreditfaktura.',
  'inv.toast.packingDownloading': 'Följesedeln laddas ner',
  'inv.toast.settledWithoutPayment': 'Fakturan är reglerad utan betalning',
  'inv.toast.sendingBackground': '{document} skickas i bakgrunden',
  'inv.toast.documentSent': '{document} skickad',
  'inv.toast.deliveredExternally': 'Dokumentet är markerat som levererat',
  'inv.toast.readyNoEmail': 'Dokumentet är förberett, men inget e-postmeddelande skickades.',
  'inv.toast.linkCopied': 'Länk till {number} kopierad',
  'inv.toast.documentDownloading': 'Dokumentet laddas ner',
  'inv.toast.archiveRestored': 'Hämtad från arkivet',
  'inv.toast.archived': 'Arkiverad',
  'inv.toast.creditCreated': '{document} skapad för {number}',
  'inv.act.unarchive': 'Hämta från arkivet',
  'inv.act.archive': 'Arkivera',
  'inv.act.archiveHelp': 'Flytta offerten eller orderbekräftelsen till arkivet, eller hämta tillbaka den.',
  'inv.convert.alreadyTitle': 'Offerten har redan omvandlats till:',
  'inv.convert.duplicateWarning': 'Om du skapar en till måste du själv se till att kunden inte faktureras för samma jobb två gånger.',
  'inv.convert.footerHelp': 'Båda skapas som utkast med kunden och raderna från offerten och öppnas i försäljningsflödet.',
  'inv.send.title': 'Skicka {document} {number}',
  'inv.deliver.title': 'Markera som levererad',
  'inv.deliver.body': 'Använd detta när dokumentet redan har levererats till kunden på annat sätt. Inget e-postmeddelande skickas från Plumme. Bokföring, moms och betalningsstatus ändras inte, men påminnelser om oskickat dokument stoppas.',
  'inv.delivery.external': 'Levererad utanför Plumme',
  'inv.more': 'Mer',
  'inv.err.offerAlreadyConverted': 'Offerten har redan konverterats till denna dokumenttyp.',
  'sale.totalDiscount': 'Total rabatt',
  'sale.totalDiscountHelp': 'Fördelas proportionellt på alla produktrader och sparas med spårbar fördelning.',
  'sale.det.currency': 'Dokumentvaluta',
  'sale.det.exchangeRate': 'Kurs till {currency}',
  'sale.det.exchangeRateDate': 'Kursdatum',
  'sale.det.exchangeRateSource': 'Källa för kurs',
  'sale.det.exchangeRateSourcePh': 'Till exempel Norges Bank eller avtalad kurs',
  'sale.create.needCurrencyEvidence': 'Ange en positiv kurs, ett kursdatum och en källa innan fakturan skapas.',
  'sale.preview.accountingAmount': 'Redovisningsbelopp: {amount} {currency} · kurs {rate}',
  'sale.preview.vatAccountingAmount': 'Moms i {currency}: {amount}',
});
